import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  registerData: {
    accountData: {
      accountName: null,
      type: 'individual-proctor',
      firstName: null,
      lastName: null,
      email: null,
      username: null,
      password: null,
      description: null
    }
  },
  getLocalStorage: action(function(data) {
    obx.registerData = data;
  }),
  updateAccountInfo: action(function(data) {
    for(let key in data) {
      if(data[key]) {
        var newData = data[key];
        obx.registerData.accountData[key] = newData;
        obx.registerData.accountData.username = obx.registerData.accountData.email;
      }
    }

    if(SessionStore.hasSessionStorage) {
      sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
    } else {
      document.cookie = `userData=${JSON.stringify(obx.registerData)}`;
    }
  }),
  createProctor: action(function(func) {
    SessionStore.startLoading('Loading…', 'CreateProctor');

    let data = obx.registerData.accountData;

    delete data.metadata;

    api.post(`/proctors`, data)
      .then(response => {
        SessionStore.finishLoading('CreateProctor');
        SessionStore.login(obx.registerData.accountData.username, obx.registerData.accountData.password, func);
      })
      .catch(error => {
        SessionStore.throwError(error)
      });
  })
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/RegisterStore.js